import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FaThLarge, FaSearch, FaHistory, FaHandsHelping, 
  FaBullhorn, FaChartLine, FaCloudSun, FaUser, 
  FaCog, FaSignOutAlt 
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const currentLang = i18n.language || 'mr';

  const getText = (mr, hi, en) => {
    if (currentLang === 'mr') return mr;
    if (currentLang === 'hi') return hi;
    return en;
  };

  const navItems = [
    { path: '/dashboard', label: getText('डॅशबोर्ड', 'डैशबोर्ड', 'Dashboard'), icon: <FaThLarge /> },
    { path: '/check-risk', label: getText('रिस्क तपासा', 'चेक रिस्क', 'Check Risk'), icon: <FaSearch /> },
    { path: '/history', label: getText('इतिहास', 'इतिहास', 'History'), icon: <FaHistory /> },
    { path: '/schemes', label: getText('सपोर्ट व योजना', 'सपोर्ट व योजनाएं', 'Support & Schemes'), icon: <FaHandsHelping /> },
    { path: '/advisory', label: getText('कृषी सल्ला', 'कृषि सलाह', 'Advisory'), icon: <FaBullhorn /> },
    { path: '/market', label: getText('बाजार भाव', 'मंडी भाव', 'Market Prices'), icon: <FaChartLine /> },
    { path: '/weather', label: getText('हवामान', 'मौसम', 'Weather'), icon: <FaCloudSun /> },
    { path: '/profile', label: getText('प्रोफाइल', 'प्रोफ़ाइल', 'Profile'), icon: <FaUser /> },
    { path: '/settings', label: getText('सेटिंग्ज', 'सेटिंग्स', 'Settings'), icon: <FaCog /> },
  ];

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem('auth_token');
    localStorage.removeItem('farmerProfile');
    localStorage.removeItem('is_authenticated');
    localStorage.removeItem('is_fd_admin');
    localStorage.removeItem('is_fd_super_admin');
    window.dispatchEvent(new Event('storage'));
    window.dispatchEvent(new CustomEvent('auth-change', { detail: { authenticated: false } }));
    window.location.href = '/login';
  };

  return (
    <aside className="fd-sidebar hide-mobile">
      <div className="fd-sidebar-menu">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path === '/schemes' && ['/support', '/schemes', '/interventions'].includes(location.pathname)) ||
            (item.path === '/settings' && location.pathname === '/settings');

          return (
            <NavLink 
              key={item.path} 
              to={item.path} 
              className={({ isActive: active }) => `fd-sidebar-item ${isActive || active ? 'active' : ''}`}
            >
              <span className="fd-sb-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </div>

      <div className="fd-sidebar-footer">
        <button className="fd-sidebar-item logout" onClick={handleLogout} style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }}>
          <span className="fd-sb-icon"><FaSignOutAlt /></span>
          <span>{getText('लॉगआउट', 'लॉगआउट', 'Logout')}</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
